// Allow iframes in content to be wrapped in responsive code
import $ from 'jquery';

export default function setupTagsReveal (vars){
	var $tags = $('.taxonomy-list__item');
    var $children = $('.taxonomy-list__item__child');
    $('.taxonomy-list__item__child').removeClass('taxonomy-list__item__child--open');
    $(document).on('click', '.taxonomy-list__item', function (e) {
        var $this = $(this);
        if ($this.hasClass('taxonomy-list__item')) {
            $this.find('.taxonomy-list__item__child').toggleClass('taxonomy-list__item__child--open');
            $tags.not($this)
                .find('.taxonomy-list__item__child')
                .removeClass('taxonomy-list__item__child--open');
        } else {
           $children.removeClass('taxonomy-list__item__child--open');
        }
    });
}